/**
 *
 * ImportScreen
 *
 */

import React from "react"
import "./index.less"
import alertCircle from "images/alert-red-circle.svg"
import alertCircleGray from "images/alert-gray-circle.svg"
import DOMPurify from "dompurify"

/* eslint-disable react/prefer-stateless-function */
const ImportScreen = (props) => {
  const sanitizedHTML = DOMPurify.sanitize(props.description);

  return (
    <div className="import-screen">
      <img className="import-screen-image" src={props.image} />
      <div className="import-screen-description">
        <p style={{ fontWeight: 600, fontSize: 16 }}>{props.title}</p>
        <p
          style={{ margin: "1rem", lineHeight: "32px" }}
          dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
        />
      </div>
      <div className="import-screen-instructions-wrapper">
        <div className="import-screen-instructions">
          <span style={{ marginBottom: "1rem", fontWeight: 600 }}>
            Instrucciones:
          </span>
          <p style={{ marginLeft: "1rem", marginRight: "1rem" }}>
            1. Descarga la plantilla de Excel.
            <br />
            2. {props.secondPoint}
            <br />
            {props.type === "divisions-assignment"  && (
              <div className="import-screen-alert">
                <div className="import-screen-alert-left">
                  <img src={alertCircle} />
                </div>
                <div className="import-screen-alert-right">
                  <p className="import-screen-alert__text">
                    <span className="import-screen-alert__highlight">Recuerda:</span> Ten tus <b>colaboradores activados en Visma People</b> para asegurar la correcta <br />asignación de tus divisiones.
                  </p>
                </div>
              </div>
            )}
            3. {props.thirdPoint}
            <br />
          </p>
        </div>
        {props.type === "divisions-assignment" && (
          <p className="import-screen-visma-people-note">
            <span>
              <img src={alertCircleGray} />
            </span>
            Para más información sobre la asignación de divisiones, ingresa a nuestro <b>Help Center</b> haciendo <a href="https://intercom-help.eu/mandu/es/articles/614852-guia-rapida-actualizacion-de-divisiones-en-engagement-con-visma-people" target="_blank">click aquí</a>.
          </p>
        )}
      </div>
      
      <div
        style={{ display: "flex", justifySelf: "center", marginTop: "2rem" }}>
        {props.children}
      </div>
    </div>
  )
}

ImportScreen.propTypes = {}

export default ImportScreen
